import React from "react";
import "./StatusIndicator.css";

const StatusIndicator = ({
  text = "",
  variant = "info", // info | success | danger
  indicator_type = "", // '' | 'voice'
  onClickComp=()=>{}
}) => {
  const wrapperClass = `status-indicator-wrapper status-${variant}`;
  const indicatorClass =
    indicator_type === "voice" ? "glow-voice" : "glow-dot";

  return (
    <div className={wrapperClass} onClick={onClickComp}>
      <div className={indicatorClass}></div>
      {text && <span className="status-text">{text}</span>}
    </div>
  );
};

export default StatusIndicator;
